function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.924 6.552a3.628 3.628 0 0 1 3.628-3.628h8.93a.837.837 0 1 0 0-1.674h-8.93a5.3 5.3 0 0 0-5.3 5.3v13.4a5.3 5.3 0 0 0 5.3 5.3h13.4a5.3 5.3 0 0 0 5.3-5.3v-8.93a.837.837 0 1 0-1.674 0v3.917q-.076-.06-.157-.115l-2.658-1.772a4.465 4.465 0 0 0-5.634.558l-3.753 3.753a4.465 4.465 0 0 1-5.634.558l-2.818-1.878zM21.9 2.087a.837.837 0 1 0-1.674 0V4.6h-2.511a.837.837 0 0 0 0 1.674h2.512v2.511a.837.837 0 1 0 1.674 0V6.273h2.512a.837.837 0 1 0 0-1.674H21.9zM9.343 12.134a2.791 2.791 0 1 0-2.791-2.791 2.791 2.791 0 0 0 2.791 2.791z",
    transform: "translate(-1.25 -1.25)",
    style: {
      fill: "#b2b2b2",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.16792c910bc98eefe037ebfa54c0c323.svg";
export { ForwardRef as ReactComponent };